import { createAction } from 'typesafe-actions';
import { saveToLocalStorageHelper } from '../../helpers/saveToLocalStorageHelper';
import { localStorageKey } from '../../helpers/validateLocalStorage';
import type { SystemState } from '../reducer/v2/system';

export const _updateSystemSettingsAction =
  createAction('system/update')<Partial<SystemState>>();

export const _updateCurrentRoute = createAction(
  'system/update_current_route',
)<string>();

export const _updateUtmSource = createAction(
  'system/update_utm_source',
)<string>();

export const updateSystemSettingsAction = (
  input: Partial<SystemState>,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.systemSettings,
    input,
  });
  return _updateSystemSettingsAction(input);
};

export const updateCurrentRoute = (
  input: string,
  saveToLocalStorage = true,
) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.systemSettings,
    input: { currentRoute: input },
  });
  return _updateCurrentRoute(input);
};

export const updateUtmSource = (input: string, saveToLocalStorage = true) => {
  saveToLocalStorageHelper({
    saveToLocalStorage,
    key: 'input',
    localStorageKey: localStorageKey.systemSettings,
    input: {
      utmSource: input,
    },
  });
  return _updateUtmSource(input);
};
